// @need-translate
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Separator} from '../../atoms/Separator/Separator';
import {PcSearchesToolbarProps} from './PcSearchesToolbarProps.interface';

export function PcSearchesToolbar({
  autoSaveRecentKeyword,
  shouldShowRemoveAllRecentKeyword,
  onClickSaveOrNotRecentKeyword,
  onClickRemoveAllRecentKeyword,
  onClickClose,
  className,
  ...props
}: PcSearchesToolbarProps) {
  return (
    <div
      className={twMerge(
        'font-small2 flex h-40pxr items-center rounded-8pxr rounded-t-none bg-theme-solid-10 px-11pxr text-theme-solid-60',
        className
      )}
      {...props}
    >
      <div
        className="flex-1 text-left"
        {...putTiaraObjectProps({
          click: {copy: autoSaveRecentKeyword ? 'off' : 'on'},
        })}
      >
        {onClickSaveOrNotRecentKeyword && (
          <button type="button" onClick={onClickSaveOrNotRecentKeyword}>
            {autoSaveRecentKeyword
              ? t('search_before_off_save')
              : t('search_before_on_save')}
          </button>
        )}
      </div>
      {shouldShowRemoveAllRecentKeyword && onClickRemoveAllRecentKeyword && (
        <>
          <button type="button" onClick={onClickRemoveAllRecentKeyword}>
            전체 삭제
          </button>
          <Separator className="mx-8pxr h-12pxr bg-theme-transparent-20" />
        </>
      )}
      <button onClick={onClickClose} type="button">
        {t('common_close_button')}
      </button>
    </div>
  );
}
